import { ContainerModule } from 'inversify';
import { PlayerModuleSymbol } from '../api';
// import { QuestionBankService, QuestionBankServiceSymbol } from './question-bank-service';
// import { QuestionProgressService, QuestionProgressServiceSymbol } from './question-progress-service';
// import { RecalculateQuestionsProgress } from '@/app/question/listeners/recalculate-questions-progress';
import { EventStreamListenerSymbol } from '@/app/event-stream';
import * as Service from './service'
import * as Store from './store'
import { QuestionStateSerializer, QuestionStateProtobufSerializer } from './tracking/serialization'
import { QuestionPlayerModule } from './question-player-module';

const questionModule = new ContainerModule((bind) => {
  // bind<QuestionBankService>(QuestionBankServiceSymbol).to(QuestionBankService);
  // bind<QuestionProgressService>(QuestionProgressServiceSymbol).to(QuestionProgressService);

  // bind(RecalculateQuestionsProgress).toSelf().inSingletonScope();
  // bind(EventStreamListenerSymbol).toDynamicValue((c) => c.container.get(RecalculateQuestionsProgress));

  // player module
  bind(PlayerModuleSymbol).to(QuestionPlayerModule)

  // serializer
  bind(QuestionStateSerializer).toSelf()
  bind(QuestionStateProtobufSerializer).toSelf()
});

export const questionModules = [
  questionModule,
  Service.questionServiceModule,
  Store.questionStateModule
]
